module.exports = __webpack_public_path__ + "assets/6417840df8cd08d8ceba2ff954b22a94.mp3";